import styled from 'styled-components';
import type { DataPort } from '@glueapp/graph-types';
import { InPort } from './Ports';

const List = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
    margin-bottom: 8px;
`;

interface Props {
    ports: DataPort[];
}

export const InPortList: React.FC<Props> = ({ ports }) => {
    return (
        <List>
            {ports.map((port, index) => (
                <InPort key={index} port={port} />
            ))}
        </List>
    );
};
